import React from 'react';
import './BookingHoldModal.css';

interface BookingHoldModalProps {
  isOpen: boolean;
  message: string;
  onConfirm: () => void;
}

const BookingHoldModal: React.FC<BookingHoldModalProps> = ({
  isOpen,
  message,
  onConfirm
}) => {
  if (!isOpen) return null;

  return (
    <div className="booking-hold-modal-overlay" onClick={onConfirm}>
      <div className="booking-hold-modal" onClick={(e) => e.stopPropagation()}>
        <div className="booking-hold-header">
          <div className="booking-hold-icon">
            <svg width="60" height="60" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" stroke="#f39c12" strokeWidth="2" fill="#fff9f0"/>
              <path d="M12 6v6l4 2" stroke="#f39c12" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <h2>Service Request Received</h2>
        </div>
        
        <div className="booking-hold-content">
          <p>{message}</p>
        </div>
        
        <div className="booking-hold-actions">
          <button className="booking-hold-ok-btn" onClick={onConfirm}>
            OK, Got it!
          </button>
        </div>
      </div>
    </div>
  );
};

export default BookingHoldModal;